import { useState, useCallback, useEffect } from "react";

import { gql } from "apollo-boost";

import { AppContextDefaultValue } from "./AppContext";
import Client from "../services/apollo";
import { App as AppInterface } from "../interfaces/app";

import * as Auth from "../services/auth";

const GET_USER = gql`
  query getUser {
    getUser {
      id
      name
      email
      cic
      phone
      status
      photo
    }
  }
`;

export const useAppHandlers = () => {
  const [appState, setAppState] = useState<AppInterface>({
    ...AppContextDefaultValue,
  });

  const login = useCallback((token: string) => {
    Auth.login(token);
    const { innerWidth } = window;
    if (innerWidth >= 1000) {
      document.location.reload();
    }
    setAppState((prevState) => ({
      ...prevState,
      isAuth: true,
    }));
  }, []);

  const setWelcome = useCallback(() => {
    Auth.setWelcome();
  }, []);

  const logout = useCallback(() => {
    Auth.logout();

    setAppState((prevState) => ({
      ...prevState,
      isAuth: false,
    }));
  }, []);

  const refreshUser = useCallback((fetchPolicy = "no-cache") => {
    setAppState((prevState) => ({
      ...prevState,
      loading: true,
    }));

    Client.query({
      query: GET_USER,
      fetchPolicy,
    })
      .then(({ data }) => {
        const { getUser } = data;
        setAppState((prevState) => ({
          ...prevState,
          error: false,
          loading: false,
          user: getUser,
        }));
      })
      .catch((err) => {
        setAppState((prevState) => ({
          ...prevState,
          loading: false,
          error: true,
        }));
      });
  }, []);

  useEffect(() => {
    setAppState((prevState) => ({
      ...prevState,
      isAuth: Auth.isAuthenticated(),
      login,
      logout,
      refreshUser,
      setWelcome,
    }));
  }, []);

  useEffect(() => {
    if (appState.isAuth) refreshUser("cache-first");
  }, [appState.isAuth]);

  return {
    appState,
    setAppState,
  };
};
